import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=b9a32ec8"
import script from "./Annotation.vue?vue&type=script&lang=ts"
export * from "./Annotation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports